import { ReactComponent as LogoSvg } from "../../logo2.svg";
import { useTranslation } from "react-i18next";
import "./styles.sass";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const isLtr = i18n.language === "en";

  return (
    <footer className={`footer ${isLtr ? "ltr" : "rtl"}`}>
      <ul className="footerList">
        <li>
          <a
            className="footerLink"
            href="https://alphabeta.co.il/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Footer.terms_of_use")}
          </a>
        </li>
        <li>
          <a
            className="footerLink"
            href="https://alphabeta.co.il/privacy-policy-he/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Footer.privacy_policy")}
          </a>
        </li>
        <li>
          <a
            className="footerLink"
            href="https://alphabeta.co.il/1178-2/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Footer.accessibility_statement")}
          </a>
        </li>
        <li className="footerLogo">
          <a
            className="footerLink footerLinkLogo"
            href="https://alphabeta.co.il/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LogoSvg className="footerLogoSvg" />
          </a>
        </li>
      </ul>
      <p className="footerText">{t("Footer.footerText")}</p>
    </footer>
  );
}
